import React from 'react';
import styled from 'react-emotion';

import BaseTextField from '@material-ui/core/TextField';

import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

const TextField = styled((props) => (
  <BaseTextField
    margin="dense"
    variant="outlined"
    {...props}
    InputProps={{
      classes: {
        input: 'fieldset-textfield-input',
        focused: 'fieldset-textfield-focusedInput',
      },
    }}
    InputLabelProps={{
      classes: {
        root: 'fieldset-textfield-label',
        shrink: 'fieldset-textfield-shrunkLabel',
        focused: 'fieldset-textfield-focusedLabel',
      },
    }}
  />
))`
  display: flex;
  flex: 1;
  height: 36px;
  & .fieldset-textfield-input {
    font-family: ${theme.font.family.workSans};
    font-size: 14px;
    border-color: ${colors.grey9};
  }
  & .fieldset-textfield-label {
    font-family: ${theme.font.family.workSans};
    font-size: 14px;
    transform: translate(14px, 11px) scale(1);
  }
  & .fieldset-textfield-focusedInput {
    & fieldset {
      border-color: ${colors.purple} !important;
    }
  }
  & .fieldset-textfield-focusedLabel {
    font-family: ${theme.font.family.workSans};
    color: ${colors.purple};
  }
  & .fieldset-textfield-shrunkLabel {
    transform: translate(14px, -6px) scale(0.75);
  }
`;

export default React.memo(TextField);
